import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/var/www/couponbase-frontend/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/var/www/couponbase-frontend/node_modules/next/dist/client/image-component.js");
